interface Props {
  color?: string;
}

const PlusIcon = ({ color }: Props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.5 11H13V6.5C13 6.22375 12.7762 6 12.5 6H11.5C11.2238 6 11 6.22375 11 6.5V11H6.5C6.22375 11 6 11.2238 6 11.5V12.5C6 12.7762 6.22375 13 6.5 13H11V17.5C11 17.7762 11.2238 18 11.5 18H12.5C12.7762 18 13 17.7762 13 17.5V13H17.5C17.7762 13 18 12.7762 18 12.5V11.5C18 11.2238 17.7762 11 17.5 11Z'
      fill={color ?? '#008ED1'}
    />
  </svg>
);

export default PlusIcon;
